import { toastMessage } from './toast';
import * as userAuthActions from '../Redux/Actions/user';

export const validationError = (error) => {
    let validationErrs = error.data.data && error.data.data.validations;
    return validationErrs && validationErrs.map(validationErr => toastMessage('error', validationErr));
};

export const initiateLogOut = (userID, dispatch, history) => {
    userAuthActions.userLogout({Id: userID}).then(res => {
        if(res.status === 200){
            dispatch(userAuthActions.userAuthLogout());
            localStorage.removeItem('jwt');
            history.push('/');
        }
    }).catch(err => {
        clearSession(dispatch, history);
    });
};

export const clearSession = (dispatch, history) => {
    dispatch(userAuthActions.userAuthLogout());
    localStorage.removeItem('jwt');
    history.push('/');
};